<template>
  <div class="report">
    <p class="h3">Жалоба на: {{ name }}</p>

    <AppTable
      :fields="tableFields"
      :items="tableItems"
      style="margin-top: 30px;"
    >
      <template #createdBy="{ userId, userFullName }">
        <BaseLink :href="`/user/${userId}`">
          {{ userFullName }}
        </BaseLink>
      </template>
    </AppTable>

    <div
      v-if="review"
      class="review"
    >
      <p class="review__title h4">Отзыв</p>
      <div class="review__text">
        {{ review }}
      </div>
    </div>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'reportPage',
  components: {
    BaseLink,
    AppTable
  },
  data () {
    return {
      name: '',
      review: '',
      tableFields: [
        { key: 'createdBy', label: 'Автор жалобы', sortable: true, slot: true },
        { key: 'cause', label: 'Причина', sortable: true },
        { key: 'createdAt', label: 'Время жалобы', sortable: true },
        { key: 'comment', label: 'Комментарий' }
      ],
      tableItems: []
    }
  },
  async created () {
    await this.fetchReport()
  },
  methods: {
    async fetchReport () {
      const id = this.$route.params.id

      try {
        const { data } = await this.$api.report.report(id)
        const list = data?.list ?? []

        this.name = data?.title || 'не указано.'
        this.review = data?.reviewText ?? ''

        this.tableItems = list.map(item => {
          const cause = item?.cause ?? ''
          const comment = item?.comment ?? ''
          const createdAt = item?.createdAt ?? ''
          const userId = item?.createdBy?.id ?? ''
          const name = item?.createdBy?.name ?? ''
          const surname = item?.createdBy?.surname ?? ''

          return {
            cause,
            comment,
            createdAt,
            userId,
            userFullName: `${name} ${surname}`
          }
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.report {

  .review {
    margin-top: 30px;

    &__text {
      margin-top: 12px;
      background: #1D1D1D;
      border-radius: 12px;
      min-height: 175px;
      max-width: 520px;
      padding: 16px;
      font-size: 16px;
      color: #A1A1A8;
    }
  }
}
</style>
